(ns frontend.ux-overhaul.nev.oppo.components
  (:require
    [basic-components.modal :as zap-modal]
    [frontend.ux-overhaul.nev.default-components
     :refer [section-action-dropdown render-nev-section render-nev-block section-layout]]
    [frontend.view.entity-viewers.components :as nev-components]
    [frontend.ux-overhaul.nev.interim.old-nev-components :as old-nev-components]
    [frontend.view.entity-viewers.modules :as modules]
    [frontend.view.nev.events :as events]
    [frontend.view.entity-viewers.entity-editor :as entity-editor]
    [frontend.state.current-session :as session]
    [common.localization :as loc]
    [clojure.string :as string]
    [common.features.plan :as plan]
    [frontend.view.entity-viewers.modules.associated-entities :as associated-entities]
    [frontend.view.entity-viewers.modules.risk.view :as risk-module]
    [frontend.view.modals.events :as modals]
    [common.schema.field :as field]
    [frontend.state.permissions :as f-permissions]
    [frontend.view.modals.change-pipeline.view :as change-pipeline]
    [frontend.view.modals.activity-entity-editor.view :as activity-entity-editor]
    [frontend.tenant-customizations :as tenant-customizations]
    [reagent.core :as r]
    [frontend.ux-overhaul.nev.components.activity-timeline :as activity-timeline]
    [frontend.view.modals.email-editor.view :as email-editor-modal]
    [frontend.view.entity-viewers.events.email-editor :as email-editor]
    [frontend.actions.email :as actions-email]
    [frontend.ux-overhaul.nev.components.attachments :as attachments-module]
    [ui.components.button.view :as button]
    [ui.view.transaction-process.target-transactions :as target-transactions]))

(def fees-associated-entities-attributes
  [:common/related-entities-company
   :common/related-entities-person])

(defn home-modules
  [{:keys [module-collapsed-path state-atom original-pipeline-id
           oppo-id header-fields view-id is-guest?]}]
  (let [oppo (get @session/entities oppo-id)
        tenant-schema @session/tenant-schema
        capman-re? (tenant-customizations/capman-is-real-estate-pipeline? original-pipeline-id)
        entity-viewer-args {:state-atom        state-atom
                            :view-id           view-id
                            :module-id         :oppo-information
                            :containing-entity oppo
                            :ordering          (get-in
                                                @session/view-config
                                                [view-id :modules :module-config :oppo-information
                                                 :ordering])}]
    (concat
     [{:module-id  :oppo-information
       :header     (loc/tr :nev-module/about-this-entity-type
                       [(string/lower-case (loc/tr (:entity/type oppo)))])
       :collapsed? (get-in @session/view-config (module-collapsed-path :oppo-information))
       :save-module-collapsed! (partial events/save-module-collapsed! :entity.type/oppo)
       :content
       [:div
        [entity-editor/view
         (merge
          entity-viewer-args
          {:custom-save!  (fn [attribute new-value on-success! on-error!]
                            (when (= attribute :oppo/pipeline)
                              (modals/open-modal! change-pipeline/modal-key
                                                  {:ofs-opportunity oppo
                                                   :selected-pipeline-id new-value
                                                   :original-pipeline-id original-pipeline-id
                                                   ;; Clear the empty input's local state.
                                                   :on-close! on-success!})
                              ;; call pipeline select error! to revert select value
                              (on-error!)
                              true))
           :entity-id     oppo-id
           :remove-fields (concat [:oppo/name :oppo/target-asset :common/network-drive :common/named-network-drives]
                                  (when (tenant-customizations/capman?)
                                    [:oppo/pipeline])
                                  (-> (field/entity-tag-fields tenant-schema (:entity/type oppo))
                                      (set)
                                      (disj
                                       (when capman-re?
                                         :oppo/tag-country))
                                      (into []))
                                  header-fields
                                  (when-not (= :oppo.status/passed (:oppo/status oppo))
                                    [:oppo/pass-reason-v2 :oppo/pass-reason-secondary]))})]]}
      (when (and (or (:oppo/target-asset oppo)
                     (not is-guest?))
                 (or (not (tenant-customizations/capman?))
                     (not (tenant-customizations/capman-in-real-estate-pipeline?))))
        (let [module-id :oppo-asset
              asset-type (->> oppo
                              :oppo/target-asset
                              (get @session/entities)
                              :entity/type)
              order-config-path [view-id :modules :module-config module-id asset-type :ordering]
              collapsed? false]
          (nev-components/entity-relation-module
           (merge
            {:state-atom          state-atom
             :module-id           module-id
             :view-id             view-id
             :ordering            (get-in
                                   @session/view-config
                                   order-config-path)
             :order-config-path   order-config-path
             :module-label        (if (:oppo/target-asset oppo)
                                    (loc/tr :nev-module/existing-target-asset [(loc/tr asset-type)])
                                    (loc/tr :nev-module/oppo-target-asset))
             :entity              oppo
             :forced-entity-types (or (some->> oppo
                                               :oppo/pipeline
                                               (get @session/entities)
                                               :pipeline/target-asset-types)
                                      []) ;; empty list as not to crash the app if pipeline is not found for any reason
             :pipeline-id         (->> oppo
                                       :oppo/pipeline)
             :relationship-attribute :oppo/target-asset
             :header-tools
             [:span.flex-grow.d-flex.j-end
              (when (and (not is-guest?)
                         (:oppo/target-asset oppo)
                         (not collapsed?)
                         (not (session/is-read-only-user?)))
                [nev-components/remove-attribute-icon
                 {:entity    oppo
                  :attribute :oppo/target-asset}])

              (when-let [_city (some->> oppo
                                        :oppo/target-asset
                                        (get @session/entities)
                                        :asset/city)]
                [button/secondary-open
                 {:tooltip (loc/tr :open-address-in-google-maps)}
                 [:i.fal.fa-map-marker-alt
                  {:on-click (fn [_]
                               (let [asset (->> oppo
                                                :oppo/target-asset
                                                (get @session/entities))]
                                 (.open js/window
                                        (str "https://www.google.com/maps/place/"
                                             (when-let [address (:asset/street-address asset)]
                                               (str address ","))
                                             (when-let [zip (:asset/zip-code asset)]
                                               (str zip "+"))
                                             (:asset/city asset)))))}]])]}))))])))

(defn landscape-modules
  [{:keys [module-collapsed-path oppo-id original-pipeline-id view-id]}]
  (concat
   (when-not (session/is-guest?)
     (associated-entities/modules {:entity-id oppo-id
                                   :save-module-collapsed! events/save-module-collapsed!
                                   :module-collapsed-path module-collapsed-path}))

   (when (and (session/risks-access?)
              (f-permissions/field-read-access? :oppo/risk-entities
                                                :entity.type/oppo
                                                original-pipeline-id))
     [(risk-module/risk-module-config
       {:module-label    (loc/tr :nev-module/oppo-risks)
        :module-id       :oppo-risks
        :view-id         view-id
        :nev-entity-type :entity.type/oppo
        :save-collapsed-status! (r/partial events/save-module-collapsed!
                                           (:entity/type
                                            :entity.type/oppo))
        :entity-id       oppo-id
        :add-new-button? false})])

   #_(when (session/fee-tracking?)
       [(fees/modules {:entity-id oppo-id
                       :save-module-collapsed! events/save-module-collapsed!
                       :module-collapsed-path module-collapsed-path
                       :fees-associated-entities-attributes fees-associated-entities-attributes})])))

(defmethod render-nev-block :nev-block.type/associations
  [{:keys [view-args]}]
  (let [{:keys [oppo view-id]}
        view-args]
    [:div
     [modules/view
      {:view-id  view-id
       :ordering (get-in @session/view-config [view-id :modules :ordering])
       :save-modules-order! (partial events/save-modules-order!
                                     (:entity/type oppo))
       :modules  (landscape-modules view-args)}]]))

(defmethod render-nev-block :nev-block.type/tasks
  [{:keys [view-args]}]
  (let [{:keys [oppo oppo-id]}
        view-args

        entity-ids (remove nil?
                           [oppo-id
                            (:oppo/target-asset oppo)])
        _task-entities (some->> @session/all-tasks
                                (remove :common/disabled?)
                                (filter (fn [t]
                                          (some-> t
                                                  :common/related-entities
                                                  (set)
                                                  (some entity-ids)))))]
    [:div]))

;; Section overrides

(defmethod render-nev-section :nev-section.type/oppo-info
  [{:keys [nev-section view-args]}]
  (let [{:keys [temp-atom
                original-pipeline-id header-fields
                enriched-company view-id entity-atom
                view-state-atom oppo oppo-id]}
        view-args

        _entity-ids (remove nil?
                            [oppo-id
                             (:oppo/target-asset oppo)])]
    [section-layout
     {:nev-section   nev-section
      :hide-title?   true
      :action-button nil}

     [:div
      [old-nev-components/owner-stage-rating-module
       {:entity-cursor          entity-atom
        :view-state             view-state-atom
        :entity                 oppo
        :entity-stage-attribute :oppo/stage
        :stage-entity-type      :entity.type/stage
        :stage-pipeline-id      (:oppo/pipeline oppo)
        :stage-pipeline-attribute :stage/pipeline
        :ratings-attribute      :oppo/ratings
        :owner-attribute        :oppo/owner
        :members-attribute      :common/team-members}]

      [old-nev-components/header-module
       {:component-state temp-atom
        :view-state      view-state-atom
        :related-tags-entity-id (:oppo/target-asset oppo)
        :logo-url        (:company/logo enriched-company)
        :entity          oppo
        :pipeline-id     original-pipeline-id
        :selected-fields header-fields}]

      [modules/view
       {:view-id  view-id
        :ordering (get-in @session/view-config [view-id :modules :ordering])
        :save-modules-order! (partial events/save-modules-order!
                                      (:entity/type oppo))
        :modules  (home-modules view-args)}]]]))

(defmethod render-nev-section :nev-section.type/oppo-activity
  [{:keys [nev-section view-args]}]
  (let [{:keys [oppo-id oppo]} view-args

        entity-ids (remove nil?
                           [oppo-id
                            (:oppo/target-asset oppo)])]
    [section-layout
     {:nev-section   nev-section
      :action-button
      (let [primary-entity-id oppo-id
            primary-entity (get @session/entities primary-entity-id)
            primary-entity-type (:entity/type primary-entity)
            _value-creation? (and (session/value-creation?)
                                  (or (= primary-entity-type :entity.type/investor)
                                      (and (= primary-entity-type :entity.type/holding)
                                           (some->> primary-entity
                                                    :holding/target-asset
                                                    (session/get-entity)
                                                    :entity/type
                                                    (= :entity.type/company)))))

            open-modal (fn [entity-type]
                         (modals/open-modal! activity-entity-editor/modal-key
                                             {:new-entity-type  entity-type
                                              :viewed-entity-id primary-entity-id}))]
        [section-action-dropdown
         {:label   "Add activity"
          :actions [{:label     (loc/tr :add-note)
                     :on-select #(open-modal :entity.type/note)}
                    {:label     (loc/tr :log-call)
                     :on-select #(open-modal :entity.type/note-call)}
                    {:label     (loc/tr :log-meeting)
                     :on-select #(open-modal :entity.type/note-meeting)}
                    {:label     (loc/tr :log-message)
                     :on-select #(open-modal :entity.type/note-message)}
                    {:label     (loc/tr :send-email)
                     :on-select (fn [_]
                                  (cond
                                    (not (plan/available :feature/nylas-integration
                                                         @session/tenant
                                                         @session/role))
                                    (modals/open-modal!
                                     zap-modal/modal-key
                                     {:title   (loc/tr :feature-not-in-use)
                                      :content email-editor/nylas-promo})

                                    (not (and (:account/nylas-account-id @session/account)
                                              (some #{(:account/nylas-status @session/account)}
                                                    [nil :nylas.status/active])))
                                    (modals/open-modal!
                                     zap-modal/modal-key
                                     {:title   (loc/tr :account-not-connected)
                                      :content email-editor/account-not-connected})

                                    (and (plan/available :feature/nylas-integration
                                                         @session/tenant
                                                         @session/role)
                                         (:account/nylas-account-id @session/account)
                                         (some #{(:account/nylas-status @session/account)}
                                               [nil :nylas.status/active]))

                                    (do
                                      (modals/open-modal!
                                       email-editor-modal/modal-key
                                       {:title-text         [:span (loc/tr :mail-from)
                                                             [:span
                                                              (:account/nylas-email
                                                               @session/account)]]
                                        :entity-id          primary-entity-id
                                        :on-primary-submit! actions-email/*->send-email})
                                      true)

                                    :else (do (js/console.log "unhandled condition")
                                              false)))}]}])}

     [activity-timeline/view {:entity-ids entity-ids}]]))

(defmethod render-nev-section :nev-section.type/oppo-transactions
  [{:keys [nev-section view-args]}]
  (let [{:keys [oppo]} view-args]
    [section-layout
     {:nev-section nev-section}
     [target-transactions/view
      {:target oppo
       :create-initial-values {:short-name (:oppo/name oppo)
                               :vehicle-id (or (-> oppo :oppo/fund :db/id)
                                               (:oppo/fund oppo))}}]]))

(defmethod render-nev-section :nev-section.type/oppo-landscape
  [{:keys [nev-section view-args]}]
  (let [{:keys [oppo view-id]} view-args

        show-empty-tables? false

        modules (->> (landscape-modules view-args)
                     (mapv (fn [module]
                             (-> module
                                 (dissoc :header-tools)
                                 (assoc :collapsed? false)))))]
    [section-layout
     {:nev-section   nev-section
      :action-button [section-action-dropdown
                      {:label   "Add association"
                       :actions (->> modules
                                     (mapv (fn [module]
                                             {:label     (str "Add " (loc/tr (:target-type module)))
                                              :on-select (:create-new-fn module)})))}]}

     (let [visible-modules (->> modules
                                (filter (fn [{:keys [has-data?]}]
                                          (or show-empty-tables?
                                              has-data?))))
           _no-visible-modules? (empty? visible-modules)]
       (if (seq visible-modules)
         [modules/view
          {:view-id  view-id
           :ordering (get-in @session/view-config [view-id :modules :ordering])
           :save-modules-order! (partial events/save-modules-order!
                                         (:entity/type oppo))
           :modules  (->> modules
                          (filter (fn [{:keys [has-data?]}]
                                    (or show-empty-tables?
                                        has-data?))))}]
         [:div "No associations yet."]))]))

(defmethod render-nev-section :nev-section.type/oppo-tasks
  [{:keys [nev-section view-args]}]
  (let [{:keys [oppo-id oppo]} view-args

        entity-id oppo-id

        entity-ids (remove nil?
                           [entity-id
                            (:oppo/target-asset oppo)])
        _task-entities (some->> @session/all-tasks
                                (remove :common/disabled?)
                                (filter (fn [t]
                                          (some-> t
                                                  :common/related-entities
                                                  (set)
                                                  (some entity-ids)))))]
    [section-layout
     {:nev-section   nev-section
      :action-button
      [button/sm-primary-solid
       {:on-click (fn [_e]
                    (modals/open-modal! activity-entity-editor/modal-key
                                        {:new-entity-type  :entity.type/task
                                         :viewed-entity-id entity-id}))}
       (str (loc/tr :add-task) " +")]}
     [:div.new-nev-tasks-table-wrapper]]))

(defmethod render-nev-section :nev-section.type/documents
  [{:keys [nev-section view-args]}]
  (let [{:keys [oppo-id oppo]} view-args
        attachment-ids (:common/attachments oppo)
        attachments (->> attachment-ids
                         (keep session/get-entity)
                         (seq))]
    [section-layout
     {:nev-section nev-section}
     [attachments-module/view
      {:entity-id   oppo-id
       :attachments attachments}]]))
